import "./shimmer.css";

const InlineLoader = () => (
  <span className="shimmer-inline-loader">
    <span className="shimmer-inline-dot" />
    <span className="shimmer-inline-dot" />
    <span className="shimmer-inline-dot" />
  </span>
);

export default InlineLoader;
